import ErrorModal from "@/components/modal/error-modal/error-modal";

const InvalidFileModal = () => {
  return ErrorModal({ title: "Invalid file provided" });
};

export default InvalidFileModal;
